import { API_URL } from "../utils";
import { CalendarResponse } from "../types/requests"; 

export default async (queries?: Map<string, string>): Promise<CalendarResponse> => {
	let queriesArray: string[] = [];
	
	if (queries) {
		queries.forEach((value, key) => {
			queriesArray.push(`${key}=${value}`);
		})
	}

	const request = await fetch(`${API_URL}/calendar?${queriesArray.join('&')}`, {
		credentials: 'include',
		cache: 'no-cache'
	});

	const jsonRequest = await request.json();

	return jsonRequest;
};
